import { render, staticRenderFns } from "./AuxiliaryLayout.vue?vue&type=template&id=352df577&scoped=true&"
import script from "./AuxiliaryLayout.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryLayout.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryLayout.vue?vue&type=style&index=0&id=352df577&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352df577",
  null
  
)

export default component.exports